import { ProjectSkillImportPage } from "@/features/projects/project-skill-import.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/import",
)({
  component: ProjectSkillImportPage,
});
